import React from "react";
import TextField from "@mui/material/TextField";

const TextAreaInput = ({
  placeholder,
  value,
  onChange,
  maxwidth,
  maxLength = 250,
  name,
  rows = 3,
  error = false,
  isDisabled = false,
}) => {
  const ModifiedTextField = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      borderWidth: "1px",
      fontFamily: "Geist, sans-serif",
      fontSize: "16px",
      maxWidth: maxwidth,
      "& fieldset": {
        borderColor: error ? "red" : "#C0C0C0",
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: error ? "red" : "#C0C0C0",
      },
      "&.Mui-focused fieldset": {
        borderColor: error ? "red" : "#aac7e7 !important",
        borderWidth: "2px !important",
      },
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#272727",
    },
    "& .MuiInputLabel-root": {
      color: error ? "red" : "#C0C0C0",
    },
    "& .MuiInputBase-input::placeholder": {
      color: error ? "red" : "grey",
    },
  };

  return (
    <TextField
      multiline
      rows={rows}
      value={value}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      variant="outlined"
      autoComplete="off"
      fullWidth
      disabled={isDisabled}
      inputProps={{ maxLength }}
      sx={{ ...ModifiedTextField }}
    />
  );
};

export default TextAreaInput;
